import { useEffect, useState } from "react";
import LiveOrdersTables from "./view1/LiveOrdersTables";
import { useParams } from "react-router-dom";
import { useNotification } from "../toster-notification/NotificationContext";
import { LiveOrderTableDTO } from "../../models/table/table.response";
import { tableService } from "../../services/tableService";
import { handleErrorNotification } from "../../utils/errorNotificatioMessage";
import Loader from "../shared/Loader";


const TablePositionPage: React.FC = () => {

    const [tables, setTables] = useState<LiveOrderTableDTO[]>([]);
    const [originalTables, setOriginalTables] = useState<LiveOrderTableDTO[]>([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [backgroundImageFile, setBackgroundImageFile] = useState<File | null>(null);
    const [backgroundImageUrl, setBackgroundImageUrl] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();


    useEffect(() => {
        fetchTables();
        fetchBackgroundImage();
    }, []);


    const handleSavePositions = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const dtos = tables.map(table => ({
                id: table.id,
                xCordinatePercentage: Math.round(table.xCordinatePercentage),
                yCordinatePercentage: Math.round(table.yCordinatePercentage),
                widthPercentage: Math.round(table.widthPercentage),
                heightPercentage: Math.round(table.heightPercentage)
            }));

            const response = await tableService.updateTablePositions(localId, dtos);

            if (response.success) {
                notify("success", "Raspored stolova je uspešno sačuvan.");
                setOriginalTables(tables);
                fetchTables();
            } else {
                notify("error", "Greška pri čuvanju rasporeda stolova", response.message || "Došlo je do greške pri čuvanju rasporeda stolova.");
            }
        } catch (error: any) {
            notify("error", "Greška pri čuvanju rasporeda stolova", "Došlo je do greške pri čuvanju rasporeda stolova.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const uploadBackgroundImage = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = "image/*";
        fileInput.onchange = (e: any) => {
            const file = e.target.files?.[0];
            if (file) {
                setBackgroundImageFile(file);
            }
        };
        fileInput.click();
    };

    const handleSaveBackgroundImage = async () => {
        if (!localId || !backgroundImageFile) {
            notify("error", "Local ID nije prosleđen ili nije odabrana slika");
            return;
        }

        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("backgroundImage", backgroundImageFile);

            const response = await tableService.updateBackgroundImage(localId, formData);

            if (response.success) {
                notify("success", "Slika pozadine je uspešno sačuvana.");
            } else {
                notify("error", "Greška pri čuvanju slike pozadine", response.message || "Došlo je do greške pri čuvanju slike pozadine.");
            }
        } catch (error: any) {
            notify("error", "Greška pri čuvanju slike pozadine", "Došlo je do greške pri čuvanju slike pozadine.");
            handleErrorNotification(error, notify);
        }
        finally {
            setLoading(false);
        }
    };

    const fetchBackgroundImage = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        try {
            const response = await tableService.getBackgroundImage(localId);
            if (response.success && response.data) {
                setBackgroundImageUrl(response.data);
            } else {
                notify("error", "Greška pri učitavanju pozadine", response.message || "Došlo je do greške pri učitavanju pozadine.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju pozadine", "Došlo je do greške pri učitavanju pozadine.");
            handleErrorNotification(error, notify);
            console.error("Error fetching background image:", error);
        }
    };

    const fetchTables = async () => {
        if (!localId) {
            notify("error", "Local ID nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await tableService.getLiveOrdersTablesByLocalId(localId);

            if (response.success && response.data) {
                setTables(response.data);
                setOriginalTables(response.data);
            } else {
                notify("error", "Greška pri učitavanju stolova", response.message || "Došlo je do greške pri učitavanju stolova.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju stolova", "Došlo je do greške pri učitavanju stolova.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };


    if (loading) {
        return <Loader />;
    }


    return (
        <section className="live-order-view1-section">
            <div className="w-layout-blockcontainer container live-order-main w-container">
                <div className="live-order-main-wrapper">
                    <div className="tables-status-layout">
                        <div className="lo-status-list">
                            <div id="w-node-_76c07ef9-b029-ce37-727a-237295575b10-1cee91cf" className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Slobodno</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info free"></div>
                                    <div>4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Poručeno</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info ordered"></div>
                                    <div>4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Primljeno</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info recived"></div>
                                    <div>4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Usluženo</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info served"></div>
                                    <div>4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Račun</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info bill"></div>
                                    <div>4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>Plaćeno</div>
                                </div>
                                <div className="lo-status-block">
                                    <div className="lo-status-point-info paid"></div>
                                    <div className="text-block-16">4</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div red-bg live-orders-info">
                                <div className="lo-status-header-div">
                                    <div>
                                        Pozivi konobara<br />
                                    </div>
                                </div>
                                <div className="lo-status-block">
                                    <img loading="lazy" src="https://cdn.prod.website-files.com/6919e066813f7ba31cee91ac/6919e1ecd45c56aefc25619d_palm.png" alt="" className="icon-size-24" />
                                    <div className="text-block-16">4</div>
                                </div>
                            </div>
                        </div>

                        <LiveOrdersTables
                            tables={tables}
                            disablePositioning={false}
                            onTablesChange={setTables}
                            backgroundImageUrl={backgroundImageFile ? URL.createObjectURL(backgroundImageFile) : backgroundImageUrl + "@ul.webp"}
                        />

                    </div>
                    <div className="admin-settings-box-div lo-table-info-block">
                        <div className="text-block-36">Ova stranice služi isključivo za podešavanje veličine i rasporeda stolova kao i za upravljanje slikom pozadine!</div>
                        <div className="div-block-60">
                            <div className="button-primary" onClick={() => handleSavePositions()}>
                                <div>Sačuvaj izmene</div>
                            </div>
                            {backgroundImageFile ? (
                                <div className="button-primary third" onClick={() => handleSaveBackgroundImage()}>
                                    <div>Sačuvaj sliku pozadine</div>
                                </div>
                            ) : (
                                <div className="button-primary third" onClick={() => uploadBackgroundImage()}>
                                    <div>Promeni sliku pozadine</div>
                                </div>
                            )}
                            <div className="button-secondary"
                                onClick={() => {
                                    setTables(originalTables);
                                    setBackgroundImageFile(null);
                                }}>
                                <div>Restartuj</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
};

export default TablePositionPage;